<template>
  <div>
    <v-snackbar
      color="success"
      multi-line="multi-line"
      v-model="status.addPlayListDia"
      style="z-index:10000"
    >
      プレイリストに登録しました。
      <v-btn dark flat @click.native="status.addPlayListDia = false">Close</v-btn>
    </v-snackbar>
    <v-snackbar
      color="success"
      multi-line="multi-line"
      v-model="status.addFavoriteDia"
      style="z-index:10000"
    >
      お気に入りに登録しました。
      <v-btn dark flat @click.native="status.addFavoriteDia = false">Close</v-btn>
    </v-snackbar>
    <v-snackbar
      color="success"
      multi-line="multi-line"
      v-model="status.sendContactDIa"
      style="z-index:10000"
    >
      送信完了しました。
      <v-btn dark flat @click.native="status.sendContactDia = false">Close</v-btn>
    </v-snackbar>
    <v-snackbar
      color="info"
      multi-line="multi-line"
      v-model="status.changeInfoDia"
      style="z-index:10000"
    >
      お客様情報を変更しました。
      <v-btn dark flat @click.native="status.changeInfoDia = false">Close</v-btn>
    </v-snackbar>
    <v-snackbar
      color="info"
      multi-line="multi-line"
      v-model="status.deleteItemDia"
      style="z-index:10000"
    >
      削除しました。
      <v-btn dark flat @click.native="status.deleteItemDia= false">Close</v-btn>
    </v-snackbar>
    <v-snackbar
      color="error"
      multi-line="multi-line"
      v-model="status.errorDia"
      style="z-index:10000"
    >
      エラーが発生しました。もう一度やり直してください。
      <v-btn dark flat @click.native="status.errorDia = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  data () {
    return {
      status: this.$store.state.snack_bar
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SnackBar.vue